import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const AcceptAdmissionInquiryMutation = graphql.persisted(
  "AcceptAdmissionInquiry",
  graphql(`mutation AcceptAdmissionInquiry($input: AcceptAdmissionInquiryInput!) {
    acceptAdmissionInquiry(input: $input) {
      admissionInquiry { id state }
      familyEnrollment { id }
      userErrors { message path }
    }
  }`)
);

export { AcceptAdmissionInquiryMutation };
export function useAcceptAdmissionInquiry() {
  return useMutation(AcceptAdmissionInquiryMutation);
}
